import { TimePicker } from '$tablet-app/src/app/components/TimePicker';
import { Weekdays } from '$tablet-app/src/app/components/Weekdays/Weekdays';
import { Alert } from '@akin-home/alerts';
import { Button } from '@akin-home/buttons/native';
import {
  makeDailyRecurrence,
  makeWeekdayRecurrence,
} from '@akin-home/recurrence';
import React, { FC } from 'react';
import styled from 'styled-components/native';

interface Props {
  reminder: Alert;
  onPressDelete?: (reminder: Alert) => void;
  onChange?: (reminder: Alert) => void;
}

const ReminderFormRow: FC<Props> = (props) => {
  const { reminder, onPressDelete, onChange } = props;

  const onToggleDay = (byweekday: number[]) => {
    const newReminder = {
      ...reminder,
      recurrence: byweekday.length
        ? makeWeekdayRecurrence({ byweekday })
        : makeDailyRecurrence(),
    };

    onChange?.(newReminder);
  };

  const handleDelete = () => onPressDelete?.(reminder);

  const onChangeTime = (_: any, start?: Date) => {
    start && onChange?.({ ...reminder, start });
  };

  return (
    <Container>
      <LeftActions>
        {/* Day Pickers */}
        <WeekdaysContainer>
          <Weekdays
            selected={reminder.recurrence?.byweekday}
            onChangeIDs={onToggleDay}
          />
        </WeekdaysContainer>

        {/* Right Side Controls */}
        <RightActions>
          <TimePicker value={reminder.start} onChange={onChangeTime} />
        </RightActions>
      </LeftActions>
      <DeleteButtonContainer>
        <Button
          variant="secondary"
          size="large"
          icon="times"
          onPress={handleDelete}
        />
      </DeleteButtonContainer>
    </Container>
  );
};

const Container = styled.View`
  flex-direction: row;
  max-width: 100%;
  justify-content: space-between;
  align-items: flex-start;
`;

const LeftActions = styled.View`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding-bottom: 16px;
  padding-right: 16px;
  flex: 1;
`;

const RightActions = styled.View`
  flex-direction: row;
  gap: 16px;
  align-items: center;
`;

const WeekdaysContainer = styled.View`
  flex: 1;
  min-width: 79%;
`;

const DeleteButtonContainer = styled.View`
  padding-top: 16px;
`;

export default ReminderFormRow;
